import React from "react";

export const Empty = () => <></>;
